import React from "react";
import { Input, Label } from "reactstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { RxUpload } from "react-icons/rx";
import InputField from "./InputField";
function InputPassword(props) {
  const { formik } = props;
  return (
    <>
      {props?.passwordType === "Database Access" ||
      props?.passwordType === "Server Access" ? (
        <div className="row">
          <div className="col-6">
            <div className="formSelectWrap">
              <InputField
                formik={formik}
                name={"platform"}
                placeholder={"Host / Domain"}
                type={"text"}
                value={formik.values.platform}
                touch={formik.touched.platform}
                error={formik.errors.platform}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="formSelectWrap">
              <InputField
                formik={formik}
                name={"port"}
                placeholder={"Port"}
                type={"text"}
                value={formik.values.port}
                touch={formik.touched.port}
                error={formik.errors.port}
              />
            </div>
          </div>
        </div>
      ) : null}
      {props?.passwordType === "Web Applications" ||
      props?.passwordType === "Cloud Services" ? (
        <div className="row">
          <div className="col-6">
            <div className="formSelectWrap">
              <InputField
                formik={formik}
                name={"platform"}
                placeholder={"Host / Domain"}
                type={"text"}
                value={formik.values.platform}
                touch={formik.touched.platform}
                error={formik.errors.platform}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="formSelectWrap">
              <InputField
                formik={formik}
                name={"username"}
                placeholder={"Username"}
                type={"text"}
                value={formik.values.username}
                touch={formik.touched.username}
                error={formik.errors.username}
              />
            </div>
          </div>
        </div>
      ) : null}
      {props?.passwordType === "Database Access" ? (
        <div className="row">
          <div className="col-6">
            <div className="formSelectWrap">
              <InputField
                formik={formik}
                name={"dbconnectionStrings"}
                placeholder={"Connection String"}
                type={"text"}
                value={formik.values.dbconnectionStrings}
                touch={formik.touched.dbconnectionStrings}
                error={formik.errors.dbconnectionStrings}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="formSelectWrap">
              <InputField
                formik={formik}
                name={"username"}
                placeholder={"Username"}
                type={"text"}
                value={formik.values.username}
                touch={formik.touched.username}
                error={formik.errors.username}
              />
            </div>
          </div>
        </div>
      ) : null}
      {props?.passwordType === "APIs" ? (
        <>
          <div className="row">
            <div className="col-6">
              <div className="formSelectWrap">
                <InputField
                  formik={formik}
                  name={"platform"}
                  placeholder={"Host / Domain"}
                  type={"text"}
                  value={formik.values.platform}
                  touch={formik.touched.platform}
                  error={formik.errors.platform}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="formSelectWrap">
                <InputField
                  formik={formik}
                  name={"apiKey"}
                  placeholder={"Api key"}
                  type={"text"}
                  value={formik.values.apiKey}
                  touch={formik.touched.apiKey}
                  error={formik.errors.apiKey}
                />
              </div>
            </div>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <div className="formSelectWrap">
              <InputField
                formik={formik}
                name={"apiSecret"}
                placeholder={"Api secret"}
                type={"text"}
                value={formik.values.apiSecret}
                touch={formik.touched.apiSecret}
                error={formik.errors.apiSecret}
              />
            </div>
          </div>
        </>
      ) : null}
      {props?.passwordType === "APIs" ||
      props?.passwordType === "Cloud Services" ? (
        <div
          className="formElmWrap fileWrap"
          style={{ marginBottom: "15px" }}
        >
          <Label>Secret file</Label>
          <Input
            id={'"secretFile"'}
            name={"secretFile"}
            placeholder={"Secret file"}
            type={"file"}
            accept=".txt, .pem,.ppk"
            onChange={(e) => props.handleFileChange(e)}
          />
          <span className="formIcon" style={{ right: "18px" }}>
            {<RxUpload />}
          </span>
        </div>
      ) : null}
      {props?.passwordType === "Server Access" ? (
        <div style={{ marginBottom: "15px" }}>
          <div className="formSelectWrap">
            <InputField
              formik={formik}
              name={"username"}
              placeholder={"Username"}
              type={"text"}
              value={formik.values.username}
              touch={formik.touched.username}
              error={formik.errors.username}
            />
          </div>
        </div>
      ) : null}

      {props?.passwordType === "Others" ? (
        <div style={{ marginBottom: "15px" }}>
          <div className="formSelectWrap">
            <InputField
              formik={formik}
              name={"other"}
              placeholder={"Other"}
              type={"password"}
              value={formik.values.other}
              touch={formik.touched.other}
              error={formik.errors.other}
            />
          </div>
        </div>
      ) : null}

      {props?.passwordType !== "APIs" &&
      props?.passwordType !== "Others" ? (
        <div className="row">
          <div className="col-6">
            <div className="formElmWrap">
              <div className="formSelectWrap">
                <InputField
                  formik={formik}
                  name={"password"}
                  placeholder={"Password"}
                  type={!props?.passwordVisible ? "password" : "text"}
                  value={formik.values.password}
                  touch={formik.touched.password}
                  error={formik.errors.password}
                />

                <span
                  className="generatePassBtn"
                  onClick={() => props?.toggleGeneratePass()}
                >
                  Generate
                </span>
                <span
                  className="formIcon"
                  onClick={() => props?.togglePassword()}
                >
                  {!props?.passwordVisible ? <FiEyeOff /> : <FiEye />}
                </span>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="formSelectWrap">
              <InputField
                formik={formik}
                name={"confirmPassword"}
                placeholder={"Confirm Password"}
                type={!props?.passwordVisible ? "password" : "text"}
                value={formik.values.confirmPassword}
                touch={formik.touched.confirmPassword}
                error={formik.errors.confirmPassword}
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default InputPassword;
